export function Spacer() {
	return <div className="flex-1 shrink"></div>;
}
